import React, { useRef, useState } from 'react'
import "./Chatbot.css"
import { IoClose } from "react-icons/io5";
import { GrFormAdd } from "react-icons/gr";
import { MdOutlineMicNone } from "react-icons/md";
import { GiMagickTrick } from "react-icons/gi";
import { MdContentCopy } from "react-icons/md";
import { HiOutlineThumbUp } from "react-icons/hi";
import { HiOutlineThumbDown } from "react-icons/hi";
import { RiLoopLeftLine } from "react-icons/ri";
import { RiChatNewLine } from "react-icons/ri";
import { BiSearchAlt } from "react-icons/bi";
import { IoHelpBuoyOutline } from "react-icons/io5";
import authservices from '../../services/authservices';
import { toast } from 'react-toastify';

const Chatbot = () => {

     const [message, setMessage] = useState("");
  const [response, setResponse] = useState("");
  const [loading, setLoading] = useState(false);
  const [chatStatus, setchatStatus] = useState(false);
    const [chatboxSidebar, setChatboxSidebar] = useState(false)

  const [chatHistory, setChatHistory] = useState([]);
   const [sidebar, setSidebar] = useState(false);
       const chat = async () => {
        try {
          const data = await authservices.chat({message:message});
          if (data.reply) {
            setResponse(data.reply)
          }
        } catch (error) {}
      };
    
const handleSend = async () => {
  console.log("call")
  inputRef.current.style.height = "36px"
  setchatStatus(true);
    if (!message.trim()) return;

    setLoading(true);

    const userMsg = message;
      setMessage("");
    setChatHistory((prev) => [...prev, { sender: "user", text: userMsg }]);

    try {
      const data = await authservices.chat({ message: userMsg });

      let aiReply = data?.reply || "No related information available on the site.";

      setResponse(aiReply);
      setChatHistory((prev) => [...prev, { sender: "bot", text: aiReply }]);
    } catch (error) {
      console.log(error,"ssssssssssss")
      setResponse("Something went wrong.");
    }

    setMessage("");
    setLoading(false);
  };
    const [toastVisible, setToastVisible] = useState(false);
  
  const copyText = () => {
    navigator.clipboard.writeText(response);
     toast.success(
            <div className="toast-ml">
              <h4 className="toast-title">Success!</h4>
              <p className="toast-message">Copied</p>
            </div>,
            {
              onClose: () => setToastVisible(false), // Reset state on close
              autoClose: 3000, // Auto-close after 3 seconds
            }
          );
  };

  // New Chat
  const newChat = () => {
    setChatHistory([]);
    setMessage("");
    setResponse("");
    setChatboxSidebar(false)
    setchatStatus(false);
  };
    const inputRef = useRef(null)


    const handleChatField = () => {
      
      const inputElement = inputRef.current
      console.log(inputElement.value,'inputElement');
console.log(inputElement,"inputElement")
        if (!inputElement) return;

        inputElement.style.height = "36px";                    
        inputElement.style.height = inputElement.scrollHeight + "px"; 

        // stop at 200px
        if (inputElement.scrollHeight > 100) {
            inputElement.style.height = "100px";
        }

    }
  return (
    <div className='chabt_main'>
        <button onClick={() => {setChatboxSidebar(false)}} className='chabt_btn' data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions" >
            <div className='chabt_btnImg'>
                <img src={require("../../assests/chatbot_img.webp")} alt=''/>
            </div>
        </button>

          <div className="offcanvas chabt_offcanvas offcanvas-end" data-bs-scroll="true" tabindex="-1" id="offcanvasWithBothOptions" aria-labelledby="offcanvasWithBothOptionsLabel">
              
              <div className="offcanvs-header chabt_canvs_hdr">
                  <button className='chabt_canva_menu' onClick={() => {setChatboxSidebar(true)}} >
                    <img src={require("../../assests/hamb_menu_icon.webp")} alt='' />
                  </button>
                  <div className='chabt_canva_logo'>
                    <img src={require("../../assests/binarge_bot_logo.webp")} alt='' />
                  </div>
                  <button type="button" className="chabt_canva_close" data-bs-dismiss="offcanvas"><IoClose /></button>
              </div>

              <div className="offcanvas-body chabt_canvs_bdy" onClick={() => {setChatboxSidebar(false)}}>
{!chatStatus && (
                <div className='chtbt_strt_screen'>
                    <div className='chtbt_strt_scrWrp'>
                        <h4>HI,</h4>
                        <p>How can I assist you today?</p>
                        <div className='chtbt_strt_ChipWrp'>
                            <div onClick={()=>{
                              setMessage('How binarge work ?')
                              // handleSend()
                            }}className='chtbt_strt_ChipItm'>
                                 <img src={require("../../assests/chtbt_strt_scrImg1.webp")} alt=''/> 
                                <span>How binarge work ?</span>
                            </div>
                            <div onClick={()=>{
                              setMessage('Is Binarge secure?')
                              // handleSend()
                            }}className='chtbt_strt_ChipItm'>
                                <img src={require("../../assests/chtbt_strt_scrImg2.webp")} alt=''/>
                                <span>Is Binarge secure?</span>
                            </div>
                            <div onClick={()=>{
                              setMessage('What kind of security protocols does Binarge use?')
                              // handleSend()
                            }}className='chtbt_strt_ChipItm'>
                                <img src={require("../../assests/chtbt_strt_scrImg3.webp")} alt=''/>
                                <span>What kind of security protocols does Binarge use?</span>
                            </div>
                        </div>
                    </div>
                </div>)}

                <div className={`${chatHistory?.length > 0 ? 'chtbt_txt_screen' : ''}`}>
                    <div className='chtbt_txt_scrWrp'>
                       {chatHistory.map((msg, i) => (
                        <>
    {msg.sender === "user" && (
      <div className='chtbt_txt_qstmsg'>
        <p>{msg.text}</p>
      </div>
    )}

    {msg.sender === "bot" && (
      <div className='chtbt_txt_answerMsg'>
        <div className='chtbt_txt_answerMsgtxt'>
          <p>{msg.text}</p>
        </div>

        <div className='chtbt_txt_answerMsgIcon'>
          <span onClick={() => copyText(msg.text)}>
            <MdContentCopy />
          </span>
          {/* <span><HiOutlineThumbUp /></span>
          <span><HiOutlineThumbDown /></span>
          <span><RiLoopLeftLine /></span> */}
        </div>

      </div>
      )}
  </>
))}

                    </div>
                </div>
              </div>

              <div className="offcanvas-footer chabt_canvs_footr">
                  <div className='chabt_canvs_ftwrp'>
                    {/* <button className='chabt_can_ftr_add'>
                    <GrFormAdd />
                  </button> */}
                  <textarea autoFocus="true" ref={inputRef} onInput={handleChatField} 
                 onChange={(e) => setMessage(e.target.value)}value={message} 
               onKeyDown={(e) => e.key === "Enter" && !e.shiftKey && handleSend()}
                  className='chabt_can_ftr_input' />
                  <div className='chabt_can_ftr_sendWrp'>
                    {/* <span className='chabt_can_ftr_mic'>
                        <MdOutlineMicNone />
                    </span> */}
                   {loading?
                   <button  className='chabt_can_ftr_send' >
                  <i class="fa-solid fa-circle-notch fa-spin"></i></button>:
<button  onClick={handleSend} disabled={loading}className='chabt_can_ftr_send' >
                        <img src={require("../../assests/send_arrw_icon.webp")} alt='' />
                    </button>
}
                  </div>
                  </div>
              </div>

              {/* {
                  chatboxSidebar ?
                      ( */}
                          <div className={`chabt_canvs_sdebar ${chatboxSidebar ? 'chabt_canvs_sdeAct' : 'chabt_canvs_sdeCls'}`}>
                              <div className='chabt_canvs_sidHdr'>
                                <img src={require("../../assests/chtbt_strt_scrImg2.webp")} alt='' />
                                <span onClick={() => {setChatboxSidebar(false)}}><IoClose /></span>
                              </div>
                              <ul className='chabt_canvs_sidmenu'>
                                <li onClick={newChat}>
                                    <span><RiChatNewLine /></span>
                                    New Chat
                                </li>
                                {/* <li>
                                    <span><BiSearchAlt /></span>
                                    Search in chat
                                </li>   
                                <li>
                                    <span><IoHelpBuoyOutline /></span>
                                    Help
                                </li>    */}
                              </ul>
                          </div>
                      {/* ) : null
              } */}
              
          </div>
    </div>
  )
}

export default Chatbot

